import React, { Fragment, useEffect } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  FeatureCard,
  Hero,
  Gallery,
  SpacerV,
  Stats,
} from "../components/Hero";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WindowIcon from "@mui/icons-material/Window";
import TabIcon from "@mui/icons-material/Tab";
import DvrIcon from "@mui/icons-material/Dvr";
import BlurOnIcon from "@mui/icons-material/BlurOn";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import Lottie from "react-lottie";
import { useNavigate } from "react-router";
import { Collage, Collage2, FAQ2 } from "../components/Sections";

export default function Ecommerce() {
  useEffect(() => {}, []);
  const dark = true;

  const state = useSelector((state) => state);
  const navigate = useNavigate();
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div className="anigrad">
          <div
            style={{
              height: "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "75vw",
              }}
            >
              <div
                style={{
                  fontSize: state.auth.isMobile
                    ? state.auth.isTablet
                      ? "5.2vw"
                      : "22px"
                    : "2.2vw",

                  color: "white",
                  zIndex: 999,
                }}
              >
                Revolutionizing Retail <br />
                <span style={{ color: "yellow" }}>One Click at a Time.</span>
              </div>
              <div
                style={{
                  borderBottom: "2px solid white",
                  width: "100%",
                  margin: "25px 0px 25px 0px",
                }}
              ></div>
              <div
                style={{
                  fontSize: state.auth.isMobile ? "25px" : "4.4vh",
                  color: "white",
                  zIndex: 999,
                }}
              >
                Empowering businesses and customers through seamless online
                shopping experiences.
              </div>
            </div>
          </div>
        </div>
        <Stats />

        <ContentSideBySideInv
          title={<h2>Key Benefits of Our Ecommerce Solutions</h2>}
          subtitle={
            <div>
              <div
                style={{ display: "flex", color: "black", fontWeight: "bold" }}
              >
                <CheckCircleIcon
                  style={{
                    fontSize: "3.6vh",
                    color: "orange",
                    marginRight: "15px",
                  }}
                />
                Business Analysis and Storefront Planning
              </div>
              We analyze business needs and define e-commerce goals. Our team
              structures storefront layouts that improve product visibility. We
              also optimize categories and filters for easy navigation.
              <br />
              <br />
              <div
                style={{ display: "flex", color: "black", fontWeight: "bold" }}
              >
                <CheckCircleIcon
                  style={{
                    fontSize: "3.6vh",
                    color: "blue",
                    marginRight: "15px",
                  }}
                />
                Custom Ecommerce Development and Integration
              </div>
              We develop feature-rich e-commerce stores that provide a seamless
              shopping experience. Our team integrates payment gateways and
              third-party tools. We also work on backend efficiency to improve
              speed and security.
              <br />
              <br />
              <div
                style={{ display: "flex", color: "black", fontWeight: "bold" }}
              >
                <CheckCircleIcon
                  style={{
                    fontSize: "3.6vh",
                    color: "teal",
                    marginRight: "15px",
                  }}
                />
                User Experience (UX) and Checkout Optimization
              </div>
              We design intuitive checkout flows that reduce cart abandonment.
              Our team simplifies the payment process and improves transaction
              security. We also refine product pages for better conversions.
            </div>
          }
          image={
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: require("../img/ecom.json"),
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
              height={state.auth.isMobile ? 350 : 500}
              width={state.auth.isMobile ? 350 : 500}
              isStopped={false}
              isPaused={false}
            />
          }
        />
        {!state.auth.isMobile ? (
          <SpacerV height={"100px"} background="white" />
        ) : (
          ""
        )}

        <SpacerV height={"6vh"} background="white" />

        <ThreeSideBySide
          hero={"What eCommerce Managment Services Do we Offer"}
          background={""}
          spacing={5}
          subtitle1={
            <Fragment>
              <FeatureCard
                minHeight={"40vh"}
                title={"Mobile-Optimized Shopping Experience"}
                text={`We develop responsive e-commerce stores that function smoothly on any device. A structured interface improves browsing and checkout experiences.`}
                icon={
                  <TravelExploreIcon
                    style={{
                      fontSize: state.auth.isMobile ? "25px" : "6vh",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
              <br />
              <br />
              <FeatureCard
                minHeight={"40vh"}
                title={"Maintenance and Support"}
                text={`Our team provides continuous support to update product catalogs and security patches. We monitor performance and improve store functionality.`}
                icon={
                  <TabIcon
                    style={{
                      fontSize: state.auth.isMobile ? "25px" : "6vh",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
          subtitle2={
            <Fragment>
              <FeatureCard
                minHeight={"40vh"}
                title={"Secure Payment Gateway Integration"}
                text={`We integrate trusted payment solutions that improve transaction security. Our experts implement fraud detection systems and encryption protocols.`}
                icon={
                  <DvrIcon
                    style={{
                      fontSize: state.auth.isMobile ? "25px" : "6vh",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
              <br />
              <br />
              <FeatureCard
                minHeight={"40vh"}
                title={"Advanced Search and Filtering"}
                text={`We create intelligent search systems that help customers find products quickly. Our filtering options improve discovery and increase purchase rates.`}
                icon={
                  <BlurOnIcon
                    style={{
                      fontSize: state.auth.isMobile ? "25px" : "6vh",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
          subtitle3={
            <Fragment>
              <FeatureCard
                minHeight={"40vh"}
                title={"UI/UX for Higher Engagement"}
                text={`We design visually appealing storefronts that improve navigation and user interaction. A well-structured layout increases conversions and strengthens brand identity.`}
                icon={
                  <WindowIcon
                    style={{
                      fontSize: state.auth.isMobile ? "25px" : "6vh",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
              <br />
              <br />
              <FeatureCard
                minHeight={"40vh"}
                title={"SEO-Optimized Product Listings"}
                text={`Our e-commerce experts optimize product descriptions with high-intent keywords. A structured content strategy improves search rankings and drives organic traffic.`}
                icon={
                  <DoubleArrowIcon
                    style={{
                      fontSize: state.auth.isMobile ? "25px" : "6vh",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
        />

        <FAQ2
          invert={!dark}
          q1="What makes an e-commerce website successful?"
          a1="A successful e-commerce website provides a seamless shopping experience and improves customer satisfaction. It includes a fast checkout process and secure transactions. A structured navigation system increases product visibility and drives conversions."
          q2="How long does it take to build an e-commerce store?"
          a2="Development timelines depend on features and integrations. A basic e-commerce store is completed within ten to twelve weeks. Stores with custom functionalities and advanced security measures require extended development time."
          q3="What payment gateways do you integrate?"
          a3="We integrate secure payment gateways such as Stripe and PayPal. Our team configures fraud protection systems. We also optimize checkout pages for better conversion rates."
          q4="Can I update my e-commerce website after launch?"
          a4="Yes, e-commerce stores can be updated with new products and promotions. A content management system allows businesses to manage inventory and pricing. Regular updates keep the store competitive and improve performance."
          q5="How does SEO impact e-commerce sales?"
          a5="SEO improves visibility and increases product discovery. Optimized product descriptions and structured metadata improve rankings. An SEO-focused content strategy attracts high-intent buyers and increases organic sales."
          q6="How can I improve my e-commerce conversion rates?"
          a6="A simplified checkout process reduces drop-offs and improves conversions. Optimized product pages increase engagement. Personalized recommendations encourage repeat purchases and strengthen customer loyalty."
        />
        <Stats />
        <SpacerV height={"100px"} background="#111" />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
